import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyResponse, SurveyOption } from '@nx-c4g/c4g-models';
import { BaseSurveyStepComponent } from '../base-survey-step/base-survey-step.component';
import { FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'c4g-multiple-choice-single-select-with-text-survey-step',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './multiple-choice-single-select-with-text-survey-step.component.html',
  styleUrls: ['./multiple-choice-single-select-with-text-survey-step.component.scss']
})
export class MultipleChoiceSingleSelectWithTextSurveyStepComponent extends BaseSurveyStepComponent {
  // Use this.stepData and this.emitResponse in your logic

  selectedOptionId: string | null = null;
  textValue = '';

  constructor(
    @Inject('stepData') stepData: any,
    @Inject('stepResponse') stepResponse: any,
    @Inject('initialStepResponse') initialStepResponse: any,
    private translate: TranslateService
  ) {
    super(stepData, stepResponse, initialStepResponse);
  }

  override ngOnInit() {
    super.ngOnInit();
    // Optionally initialize from initialStepResponse
    if (this.initialStepResponse && this.initialStepResponse.response?.[0]) {
      this.selectedOptionId = this.initialStepResponse.response[0]._id;
      this.textValue = this.initialStepResponse.response[0].values?.[0] || '';
    }
  }

  onSelectOption(option: SurveyOption) {
    this.selectedOptionId = option._id;
    // Clear text if switching away from text input option
    if (option.inputType !== 'text') {
      this.textValue = '';
    }
  }

  override isValid(): boolean {
    if (!this.selectedOptionId) return false;
    const selectedOption = this.stepData?.options?.find((opt: SurveyOption) => opt._id === this.selectedOptionId);
    if (!selectedOption) return false;
    if (selectedOption.inputType === 'text') {
      return this.textValue.trim().length >= 3;
    }
    return true;
  }

  override async getResponse(): Promise<SurveyResponse | undefined> {
    if (!this.selectedOptionId) return undefined;
    const selectedOption = this.stepData?.options?.find((opt: SurveyOption) => opt._id === this.selectedOptionId);
    if (!selectedOption) return undefined;
    return {
      stepId: this.stepData._id,
      showValueInReport: null,
      response: [
        {
          _id: selectedOption._id,
          values: [selectedOption.inputType === 'text' ? this.textValue : selectedOption.value]
        }
      ]
    };
  }

  emitTest() {
    this.emitResponse({
      stepId: this.stepData._id,
      showValueInReport: null,
      response: [
        { _id: 'test-option', values: ['test-value'] }
      ]
    });
  }

  getLangValue(mls: { en: string; fr: string }): string {
    const lang = this.translate.currentLang === 'fr' ? 'fr' : 'en';
    return mls?.[lang] || mls?.['en'] || '';
  }
}
